<template>
  <div class="add-team-combobox-item d-flex align-center">
    <app-button class="teams-btn-icon mr-2" type="ghost"
    >
      <app-material-icon name="group" />
    </app-button>
    <div>
      <!-- Team -->
      <div class="text-text-secondary body-md-regular">
        {{ item.name }}
      </div>
      <!-- Members -->
      <div v-if="withMembers"
                class="detail-md-regular text-text-tertiary mb-1"
      >
        <span v-t="{ path: 'subscriptions.views.SubscriptionTeams.memberCount', plural: item.members.length }" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AddTeamComboboxItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
      withMembers: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="scss">
  @import "@/scss/border-tokens";

  .add-team-combobox-item {
    .teams-btn-icon {
      width: 32px;
      height: 32px;
      min-height: 0;
      @include border-radius('border-radius-circle');
    }
  }
</style>
